import { t } from 'i18next';

import { ContextMenuItem } from '../../../../../../../react/components/skyview/context-menu';
import { isDefined } from '../../../../../../../utils/variables';
import { RevertChange } from '../../../../../../elements/design/design-node/design-node';
import { getLineSegmentCircle } from '../../../../../../elements/design/design-node/utils/circle';
import {
  findLineSegmentIdFromIntersection,
  getLineSegmentFaces,
} from '../../../../../../elements/design/design-node/utils/line-segment-node';
import { DesignTool } from '../../../../../design-tool';
import { addAndCommitAction } from '../../utils/actions';
import { deleteSelection } from '../../utils/delete-selection';
import { deselect } from '../../utils/select';

/**
 * Deletes the hovered line segment, or the whole circle or ellipse that it is an arc of.
 */
export const deleteLine = (
  tool: DesignTool,
  lineSegmentId = findLineSegmentIdFromIntersection(tool.asset.designNode, tool.intersection),
): ContextMenuItem => {
  const disabled = !isDefined(lineSegmentId);

  return {
    title: t('contextMenu.deleteLine', { ns: 'skyviewDesign' }),
    action: () => {
      let changes: RevertChange[] = [];

      if (disabled) {
        return;
      }

      addAndCommitAction(tool, {
        commit: () => {
          changes = [];
          const circle = getLineSegmentCircle(tool.asset.designNode, lineSegmentId);

          if (circle) {
            changes = deleteSelection(tool.asset.designNode, {
              points: [],
              lineSegments: circle.lineSegments,
              faces: [],
            });
            deselect(tool);
            tool.asset.designNode.refresh();
            tool.asset.refreshMetadata();
            return;
          }

          const faces = getLineSegmentFaces(tool.asset.designNode, lineSegmentId);
          faces.forEach((x) => changes.unshift(tool.asset.designNode.removeFace(x)));

          changes.unshift(tool.asset.designNode.removeLineSegment(lineSegmentId));
          deselect(tool);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
        rollback: () => {
          tool.asset.designNode.revert(changes);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
      });
      tool.cursorLine.visible = false;
      tool.contextMenuCallback?.();
    },
    disabled,
    hotkey: 'Delete',
  };
};
